/* ==============================================================
   LINES -- flowing path field (vanilla SVG)
   Builds two mirrored fans of curved paths -- the same recipe as
   the studio's Background Paths component -- then animates each
   one's stroke-dashoffset for a slow draw-and-flow. Bichrome:
   bone strokes over the ink the hero already sits on.
   ============================================================== */
(() => {
  'use strict';
  const host = document.getElementById('heroLines');
  if (!host) return;

  const NS = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(NS, 'svg');
  svg.setAttribute('viewBox', '0 0 696 316');
  svg.setAttribute('fill', 'none');
  svg.setAttribute('aria-hidden', 'true');

  const fan = (position) => {
    for (let i = 0; i < 36; i++) {
      const d = `M-${380 - i * 5 * position} -${189 + i * 6}C-${380 - i * 5 * position} -${189 + i * 6} -${312 - i * 5 * position} ${216 - i * 6} ${152 - i * 5 * position} ${343 - i * 6}C${616 - i * 5 * position} ${470 - i * 6} ${684 - i * 5 * position} ${875 - i * 6} ${684 - i * 5 * position} ${875 - i * 6}`;
      const path = document.createElementNS(NS, 'path');
      path.setAttribute('d', d);
      path.setAttribute('stroke', 'currentColor');
      path.setAttribute('stroke-width', (0.5 + i * 0.03).toFixed(2));
      path.setAttribute('stroke-opacity', Math.min(1, 0.1 + i * 0.03).toFixed(2));
      path.classList.add('lines__path');
      svg.appendChild(path);
    }
  };
  fan(1);
  fan(-1);
  host.appendChild(svg);

  const calm = matchMedia('(prefers-reduced-motion: reduce)');
  if (calm.matches) return;

  svg.querySelectorAll('path').forEach((p) => {
    const len = p.getTotalLength();
    const dur = 20 + Math.random() * 10;
    p.style.setProperty('--len', len.toFixed(1));
    p.style.setProperty('--dur', dur.toFixed(2) + 's');
    p.style.setProperty('--delay', (-Math.random() * dur).toFixed(2) + 's');
  });
})();
